import { GruppoTerritoriale } from '../gruppo-territoriale';

export class TemplateRuolo {
  id: string;
  label?: string;
  nomeRuolo?: string;
  constructor( gruppoTerritoriale: GruppoTerritoriale) {
    this.id = gruppoTerritoriale.id;
    this.nomeRuolo = gruppoTerritoriale.nomeGruppo;
  }
}
